import { formatIncompletePhoneNumber } from "libphonenumber-js";

import { DEFAULT_COUNTRY } from "../../constants";
import getSuffix from "../getSuffix";
import normalizePhoneNumber from "../normalizePhoneNumber";

export default (countryCode = DEFAULT_COUNTRY, phoneNumber = "") => {
  const normalizedPhoneNumber = normalizePhoneNumber(phoneNumber);

  /**
   * This is a workaround that prevents a bug in libphonenumber-js documented
   * here: https://github.com/catamphetamine/libphonenumber-js/issues/225
   *
   * This bug prevents users from deleting the closing parenthesis ")" in
   * US-formatted phone numbers.
   */
  if (normalizedPhoneNumber.length === 3) return phoneNumber;

  const formattedPhoneNumber = formatIncompletePhoneNumber(
    normalizedPhoneNumber,
    countryCode
  );

  const suffix = getSuffix(normalizedPhoneNumber);

  return `${formattedPhoneNumber}${suffix}`;
};
